<template>
  <page>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Selection Criteria
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
    <v-card>
      <v-card-text>
        <v-form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.ccydFrom"
                  :label="label.ccydFrom"
                  :data-vv-as="label.ccydFrom"
                  data-vv-name="ccydFrom"
                  :error-messages="errors.collect('ccydFrom')"
                  v-validate="'required'"
                  @change="ccydFromChange"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.ccydTo"
                  :label="label.ccydTo"
                  :data-vv-as="label.ccydTo"
                  data-vv-name="ccydTo"
                  :error-messages="errors.collect('ccydTo')"
                  v-validate="ccydToValidate"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.pcydFrom"
                  :label="label.pcydFrom"
                  :data-vv-as="label.pcydFrom"
                  data-vv-name="pcydFrom"
                  :error-messages="errors.collect('pcydFrom')"
                  v-validate="'required'"
                  @change="pcydFromChange"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.pcydTo"
                  :label="label.pcydTo"
                  :data-vv-as="label.pcydTo"
                  data-vv-name="pcydTo"
                  :error-messages="errors.collect('pcydTo')"
                  v-validate="pcydToValidate"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.apedFrom"
                  :label="label.apedFrom"
                  :data-vv-as="label.apedFrom"
                  data-vv-name="apedFrom"
                  :error-messages="errors.collect('apedFrom')"
                  v-validate="'required'"
                  @change="apedFromChange"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.apedTo"
                  :label="label.apedTo"
                  :data-vv-as="label.apedTo"
                  data-vv-name="apedTo"
                  :error-messages="errors.collect('apedTo')"
                  v-validate="apedToValidate"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <v-text-field
                  v-model="form.polType"
                  :label="label.polType"
                  :error-messages="errors.collect('polType')"
                  :data-vv-as="label.polType"
                  data-vv-name="polType"
                  append-icon="mdi-magnify"
                  @click:append="multiPolTypeHelpList = true"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  readonly
                  v-model="form.busCls"
                  :label="label.busCls"
                  :error-messages="errors.collect('busCls')"
                  data-vv-name="busCls"
                  :data-vv-as="label.busCls"
                  append-icon="mdi-magnify"
                  @click:append="multiBusClsList = true"
                  ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  :label="label.riType"
                  :items="riTypeList"
                  v-model="form.riType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="riType"
                  :data-vv-as="label.riType"
                  :error-messages="errors.collect('riType')"
                ></v-autocomplete>
              </v-flex>
               <v-flex xs12 sm12 md12>
                <v-text-field
                  readonly
                  v-model="form.riRefNo"
                  :label="label.riRefNo"
                  :error-messages="errors.collect('riRefNo')"
                  data-vv-name="riRefNo"
                  :data-vv-as="label.riRefNo"
                  append-icon="mdi-magnify"
                  :disabled="form.riType === 'D'"
                  @click:append="riRefNoHelpList()"
                  ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="form.fund"
                    :label="label.fund"
                    :error-messages="errors.collect('fund')"
                    data-vv-name="fund"
                    :data-vv-as="label.fund"
                    append-icon="mdi-magnify"
                    readonly
                    @click:append="multiFundHelpList = true"
                  ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  :label="label.rptType"
                  :items="reportTypeList"
                  v-model="form.rptType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rptType"
                  :data-vv-as="label.rptType"
                  :error-messages="errors.collect('rptType')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  :label="label.sortRptBy"
                  :items="sortReportByList"
                  v-model="form.sortRptBy"
                  item-text="value"
                  item-value="code"
                  data-vv-name="sortRptBy"
                  :data-vv-as="label.sortRptBy"
                  :error-messages="errors.collect('sortRptBy')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
          <v-dialog v-model="multiBusClsList" width="900px" persistent>
            <multi-bus-cls-help-list :busCls="form.busCls" @close="doClose" @doAssign="doAssignBusCls($event)"></multi-bus-cls-help-list>
          </v-dialog>
          <v-dialog v-model="multiPolTypeHelpList" width="900px" lazy persistent>
            <multi-pol-type-help-list @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
          </v-dialog>
          <v-dialog v-model="multiFundHelpList" width="900px" persistent>
            <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignFund($event)"></multi-fund-help-list>
          </v-dialog>
          <v-dialog v-model="multiIntermediaryHelpList" width="900px" persistent>
            <multi-intermediary-help-list :intr="form.riRefNo" intrGrp="20" helpListTitle="RI Ref No. HelpList" @close="doClose" @doAssign="doAssignRiRefNo($event)"></multi-intermediary-help-list>
          </v-dialog>
           <v-dialog v-model="multiTreatyRefNoHelpList" width="900px" persistent>
            <multi-treaty-ref-no-help-list :ttyrefno="form.riRefNo" :ritype="form.riType" helpListTitle="RI Ref No. HelpList" @close="doClose" @doAssign="doAssignRiRefNo($event)"></multi-treaty-ref-no-help-list>
          </v-dialog>
        </v-form>
      </v-card-text>
    </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
              <v-flex xs12>
              <v-checkbox
                      :label="label.pbPrtParam"
                      v-model="form.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="label.pbPrtParam"
                    />
                  </v-flex>
              <v-flex xs12 class="pt-2">
                <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ label.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
  </page>
</template>
<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import MultiTreatyRefNoHelpList from '@/components/core/common/dialog/MultiTreatyRefNoHelpList.vue'
import MessageMixin from '@/mixins/message'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
export default {
  data() {
    return {
      label: {
        ccydFrom: 'Current Claims Year Date From*',
        ccydTo: 'Current Claims Year Date To*',
        pcydFrom: 'Previous Claims Year Date From*',
        pcydTo: 'Previous Claims Year Date To*',
        apedFrom: 'Account Period End Date From*',
        apedTo: 'Account Period End Date To*',
        polType: 'Policy Type',
        busCls: 'Business Class',
        riType: 'RI Type',
        riRefNo: 'RI Ref No.',
        fund: 'Fund',
        rptType: 'Report Type',
        sortRptBy: 'Sort Report By',
        export: 'Export To',
        pbPrtParam: 'Print Runtime Parameters'
      },
      labels: {
        rptType: 'xx'
      },
      form: {
        ccydFrom: null,
        ccydTo: null,
        pcydFrom: null,
        pcydTo: null,
        apedFrom: null,
        apedTo: null,
        polType: 'All',
        busCls: 'All',
        riType: 'C',
        riRefNo: 'All',
        fund: 'All',
        rptType: 'B',
        sortRptBy: 'lossYear',
        format: 'PDF',
        pbPrtParam: true
      },
      supportedFormat: [],
      loading: false,
      multiBusClsList: false,
      multiPolTypeHelpList: false,
      multiFundHelpList: false,
      multiIntermediaryHelpList: false,
      multiTreatyRefNoHelpList: false,
      menu: {},
      riTypeList: [
        {
          value: 'All',
          code: 'A'
        },
        {
          value: 'Coinsurance',
          code: 'C'
        },
        {
          value: 'Statutory',
          code: 'D'
        },
        {
          value: 'Facultative',
          code: 'F'
        },
        {
          value: 'Treaty',
          code: 'T'
        },
        {
          value: 'Quota Share',
          code: 'W'
        }
      ],
      reportTypeList: [
        {
          value: 'Summary',
          code: 'S'
        },
        {
          value: 'Detail',
          code: 'D'
        },
        {
          value: 'Both',
          code: 'B'
        }
      ],
      sortReportByListData: [
        {
          value: 'Loss Year',
          code: 'lossYear'
        },
        {
          value: 'UW Year',
          code: 'uwYear'
        },
        {
          value: 'Claim Year',
          code: 'claimYear'
        },
        {
          value: 'Treaty Year',
          code: 'treatyYear'
        }
      ],
      panel: [0]
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
  },
  watch: {
    'form.riType': function() {
    }
  },
  computed: {
    sortReportByList() {
      let data = []
      if (this.form.riType !== 'T' && this.form.riType !== 'W') {
        data = [
          { value: 'Loss Year', code: 'lossYear' },
          { value: 'UW Year', code: 'uwYear' },
          { value: 'Claim Year', code: 'claimYear' }
        ]
      } else {
        data = this.sortReportByListData
      }
      return data
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    ccydToValidate() {
      if (this.form.ccydFrom) {
        return 'required|valMinDate:' + this.form.ccydFrom
      } else {
        return 'required'
      }
    },
    pcydToValidate() {
      if (this.form.pcydFrom) {
        return 'required|valMinDate:' + this.form.pcydFrom
      } else {
        return 'required'
      }
    },
    apedToValidate() {
      if (this.form.apedFrom) {
        return 'required|valMinDate:' + this.form.apedFrom
      } else {
        return 'required'
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.ttyReports.init !== 1) {
          await this.$store.dispatch('ttyReportsInit')
        }
        const apiURI = this.$store.state.reports.ttyReports.menu.ttyOsClm
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.menu.export
      if (apiUrl) {
        try {
          this.loading = true
          await this.$http.post(apiUrl, this.form)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [processExport]')
      }
      this.loading = false
    },
    ccydFromChange() {
      this.form.ccydTo = this.form.ccydFrom
    },
    pcydFromChange() {
      this.form.pcydTo = this.form.pcydFrom
    },
    apedFromChange() {
      this.form.apedTo = this.form.apedFrom
    },
    doClose() {
      this.multiBusClsList = false
      this.multiPolTypeHelpList = false
      this.multiFundHelpList = false
      this.multiIntermediaryHelpList = false
      this.multiTreatyRefNoHelpList = false
    },
    doAssignBusCls(Obj) {
      this.form.busCls = []
      this.form.busCls = Obj.finalSelectedItems.toString()
    },
    doAssignPolType(Obj) {
      this.form.polType = []
      this.form.polType = Obj.finalSelectedItems.toString()
    },
    doAssignFund(Obj) {
      this.form.fund = []
      this.form.fund = Obj.finalSelectedItems.toString()
    },
    doAssignRiRefNo(Obj) {
      this.form.riRefNo = []
      this.form.riRefNo = Obj.finalSelectedItems.toString()
    },
    riRefNoHelpList() {
      if (this.form.riType === 'C' || this.form.riType === 'F') {
        this.multiIntermediaryHelpList = true
      } else {
        this.multiTreatyRefNoHelpList = true
      }
    }
  },
  mixins: [MessageMixin],
  components: {
    MultiBusClsHelpList,
    MultiPolTypeHelpList,
    MultiFundHelpList,
    MultiIntermediaryHelpList,
    MultiTreatyRefNoHelpList
  }
}
</script>
